import React from 'react';
import { MapPin, Heart } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { motion } from 'framer-motion';
interface LocationMarkerProps {
  x: number;
  y: number;
  type: 'lake' | 'river' | 'coast';
  isSelected: boolean;
  onClick: () => void;
  locationId?: string;
}
export function LocationMarker({
  x,
  y,
  type,
  isSelected,
  onClick,
  locationId
}: LocationMarkerProps) {
  const {
    favorites
  } = useApp();
  const isFavorite = locationId ? favorites.includes(locationId) : false;
  return <motion.button onClick={e => {
    e.stopPropagation();
    onClick();
  }} className="absolute transform -translate-x-1/2 -translate-y-1/2 z-10" style={{
    left: `${x}%`,
    top: `${y}%`
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.95
  }} animate={{
    scale: isSelected ? 1.15 : 1
  }} transition={{
    type: 'spring',
    stiffness: 400,
    damping: 25
  }} data-id="element-108">
      <div className={`relative p-2 rounded-full transition-all ${isSelected ? 'bg-[var(--accent)] shadow-lg' : 'bg-[var(--bg-card)] shadow-md border border-[var(--border)]'}`} data-id="element-109">
        <MapPin className={`w-5 h-5 ${isSelected ? 'text-white' : 'text-[var(--accent)]'}`} data-id="element-110" />

        {isFavorite && <div className="absolute -top-1 -right-1 w-4 h-4 bg-rose-500 rounded-full flex items-center justify-center" data-id="element-111">
            <Heart className="w-2.5 h-2.5 text-white fill-white" data-id="element-112" />
          </div>}
      </div>
    </motion.button>;
}